import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon, Button, Section } from '@fiverr-private/fit';
import { mixpanel } from '@fiverr-private/obs';
import { r_exclamation_triangle as Triangle } from '@fiverr-private/icons/basic';
import { daysToDeadline } from '../utils';

import './style.scss';

const MIXPANEL_EVENT_NAME = 'w9.bomba.click';

const userW9Path = (username) => (
    pathfinder('edit_user_section', { id: username, section: 'w9_form' })
);

const redirect = (username) => {
    mixpanel.track(MIXPANEL_EVENT_NAME);
    window.open(userW9Path(username));
};

const TaxFormNotice = ({ deadline = Date(), username }) => (
    <aside className="bomba-wrapper">
        <Section className="bomba-content p-0 flex">
            <div className="bomba-icn">
                <Icon color="white" size={22}>{Triangle}</Icon>
            </div>
            <div className="bomba-text text-trunc text-semi-bold">
                <I18n k="layout.global_messages.tax_form.label" params={{ count: daysToDeadline(deadline) }}/>
            </div>

            <Button onClick={() => redirect(username)} className="link-provider tbody-6"
                color={Button.COLORS.WHITE}
                fill={Button.FILLS.FULL}
                textColor={Button.TEXT_COLORS.ORANGE}>
                <I18n k="layout.global_messages.tax_form.submit"/>
            </Button>
        </Section>
    </aside>
);

TaxFormNotice.propTypes = {
    username: string.isRequired,
    deadline: string
};

export default TaxFormNotice;
